import { IResponseState } from "../../../../../components/Modals/ResponseModal/module/constants";
import { STATE_IDENTIFIER } from "./constants";

const { PARAMETERS, PARAM_DEL_STATE, PARAM_ADD_EDIT_STATE, LOADER_IDENTIFIER } =
  STATE_IDENTIFIER;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [PARAMETERS]: [],
  [PARAM_DEL_STATE]: IResponseState.PENDING,
  [PARAM_ADD_EDIT_STATE]: IResponseState.PENDING,
  [LOADER_IDENTIFIER]: false,
};
